import { isActualProduct } from './isActualProduct';

import { ProductQty, SelectedItemMap } from '~/core/models';

// this creates a minimal PricedProduct from a list of selected products, only valid products allowed
export const productQtyFromSelectedItems = (
  selectedItems: SelectedItemMap
): ProductQty[] =>
  Object.entries(selectedItems)
    .filter(
      ([productId, selectedItem]) =>
        selectedItem.isSelected &&
        selectedItem.quantity > 0 &&
        isActualProduct(Number(productId))
    )
    .map(([productId, selectedItem]) => ({
      productId: Number(productId),
      quantity: selectedItem.quantity,
    }));
